import React from 'react';

export default class SizeWatcher extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.handleResize = this.handleResize.bind(this);
    this.saveNode = this.saveNode.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.setState({ // eslint-disable-line react/no-did-mount-set-state
      width: this.wrapNode.offsetWidth,
      height: this.wrapNode.offsetHeight,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const childrenWithProps = this.state.width && this.state.height && React.Children.map(this.props.children,
      (child) => React.cloneElement(child, {
        width: this.state.width,
        height: this.state.height,
      })
    );

    return (<div
      className={this.props.className}
      ref={this.saveNode}
    >
      {childrenWithProps || null}
    </div>);
  }

  saveNode(node) {
    this.wrapNode = node;
  }

  handleResize() {
    this.setState({
      width: this.wrapNode.offsetWidth,
      height: this.wrapNode.offsetHeight,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/SizeWatcher.js